import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
    apiKey: "AIzaSyBG-PvQCFg8FP6GkQQ2TzAby7QLFfdM3PE",
    authDomain: "legalia.firebaseapp.com",
    projectId: "legalia",
    storageBucket: "legalia.firebasestorage.app",
    messagingSenderId: "807258921721",
    appId: "1:807258921721:web:a082327734bf9da0832028",
    measurementId: "G-44ENYXFR83"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };